import React from "react";
import { useTranslation } from "react-i18next";
import { PlaneIcon } from "./icons";

export const FlightAlertsHeader: React.FC = () => {
  const { t } = useTranslation("flightAlerts");
  return (
    <div className="flex shrink-0 items-center gap-2">
      <PlaneIcon className="w-5 h-5 text-brand-blue" />
      {/* Figma spec: Lexend Deca, Regular 400, 14px/18px, 0 letter-spacing,
          ink/100 (#0F151A) — same on mobile and desktop (DASH-6077). Whitespace kept on one
          line -- shrinking to fit a row it shares with the sign-in link wrapped this mid-word
          at narrow widths, which reads as broken rather than intentional wrapping. */}
      <span className="whitespace-nowrap font-lexend text-[14px]/[18px] font-normal tracking-normal text-ink-100">
        {t("shared.logoTitle")}
      </span>
    </div>
  );
};
